import {
  Button,
  HStack,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { ReactComponent as CircleExclamation } from 'assets/icons/a11ymenu_alert.svg';
import { useTranslation } from 'react-i18next';

import { autoBrandDiscard } from './AutoBrand.config';

interface DiscardModalProps {
  onConfirm?: () => void;
  onClose?: () => void;
  isOpen: boolean;
}

const DiscardModal = ({ onConfirm = () => {}, onClose = () => {}, isOpen }: DiscardModalProps) => {
  const { t } = useTranslation('auto_brand', { useSuspense: false, keyPrefix: 'modals.autoBrand' });

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <div id={autoBrandDiscard}>
        <ModalOverlay zIndex={'var(--vg-zIndices-popOver)'} />
        <ModalContent
          maxW={'sm'}
          m='auto'
          p='0'
          containerProps={{
            zIndex: 'var(--vg-zIndices-popOver)',
          }}
        >
          <ModalHeader>
            <Heading size={'md'}>
              <HStack gap={2}>
                <>
                  <CircleExclamation /> {t('discardBrand')}
                </>
              </HStack>
            </Heading>
          </ModalHeader>
          <ModalCloseButton data-testid={'checker-rescan-close-button'} />
          <ModalBody>
            <Text fontSize={'sm'}>{t('areYouSure')}</Text>
          </ModalBody>
          <ModalFooter>
            <Button variant={'ghost'} size={'sm'} mr={2} onClick={onClose} data-testid={'cancel-button'}>
              {t('cancel')}
            </Button>
            <Button variant={'outline'} size={'sm'} onClick={onConfirm} data-testid={'discard-confirm-button'}>
              {t('discard')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </div>
    </Modal>
  );
};

export default DiscardModal;
